import { ModuleTypes } from 'enums';
import { ApiResponse, PaginationFilters } from 'store/interfaces';
import { OrganizationAddress } from 'store/organizationAddresses/interfaces';

export enum SubscriptionType {
  trial = 'trial',
  subscription = 'subscription',
}

export enum SubscriptionStatus {
  awaiting = 'awaiting',
  active = 'active',
  cancelled = 'cancelled',
}

export interface Subscription {
  '@id': string;
  id: string;
  modules: ModuleTypes[];
  organization: string;
  seats: number;
  type: SubscriptionType;
  status: SubscriptionStatus;
  organizationAddress: OrganizationAddress;
  paymentMethod: string;
  products: string[];
}

export interface SubscriptionPostResponse extends Subscription {
  metadata: {
    clientSecret: string;
  };
}

export interface SubscriptionData extends ApiResponse {
  'hydra:member': Subscription[];
}

export interface SubscriptionFilters extends PaginationFilters {
  organization: string;
}

export enum SubscriptionInvoiceStatus {
  draft = 'draft',
  open = 'open',
  paid = 'paid',
  void = 'void',
  uncollectible = 'uncollectible',
}

export interface SubscriptionInvoice {
  '@id': string;
  amountGross: number;
  amountNet: number;
  currency: string; // only country code
  issueDate: string;
  modules: number;
  number: string;
  pdfUrl: string;
  seats: number;
  status: SubscriptionInvoiceStatus;
}

export interface SubscriptionInvoiceData extends ApiResponse {
  'hydra:member': SubscriptionInvoice[];
}

export interface SubscriptionInvoiceFilters extends Partial<PaginationFilters> {
  id: string;
  status?: SubscriptionInvoiceStatus | SubscriptionInvoiceStatus[];
  'startDate[before]'?: string;
  'dateTo[after]'?: string;
}

export interface SubscriptionMutationRequest
  extends Pick<Subscription, 'modules' | 'seats'> {
  organizationAddress: string;
}
